import { prefix } from './src/utils/constant'
import {
  mapObject
} from './src/utils'
import './common'

import bdcSelect from './src/components/form/bdc-select/bdc-select'
import provinceCityDistrict from './src/components/form/province-city-district/province-city-district'
import province from './src/components/form/province-city-district/province'
import city from './src/components/form/province-city-district/city'
import district from './src/components/form/province-city-district/district'
import advancedSearch from './src/components/form/advanced-search'
import asyncSelect from './src/components/form/async-select'
import dateRange from './src/components/form/date-range'
import formGroup from './src/components/form/form-group.vue'
import selectTree from './src/components/form/select-tree'
import towCascader from './src/components/form/tow-cascader'
import towTileSelect from './src/components/form/tow-tile-select'
import formEditItem from './src/components/form/form-edit-item'
import formCollapse from './src/components/form/form-collapse'
import numberRange from './src/components/form/number-range'
import elSelectAllOption from './src/components/form/el-select-all-option'
import elSelectSearchInput from './src/components/form/el-select-search-input'

// 添加备注公用组件
import remarkCell from './src/components/form/remark-cell'
// edit-item
import editItem from './src/components/form/edit-item'
import editFormTable from './src/components/form/edit-form/edit-form-table'
import editForm from './src/components/form/edit-form'
import editCell from './src/components/form/edit-cell'
import textareaCell from './src/components/form/textarea-cell'
let components = {
  selectTree,
  formGroup,
  dateRange,
  bdcSelect,
  province,
  city,
  district,
  provinceCityDistrict,
  advancedSearch,
  asyncSelect,
  remarkCell,
  editItem,
  editFormTable,
  editForm,
  editCell,
  textareaCell,
  formEditItem,
  towCascader,
  towTileSelect,
  formCollapse,
  numberRange,
  elSelectAllOption,
  elSelectSearchInput
}
const install = Vue => {
  mapObject(components, component => {
    if (component.name) {
      Vue.component(prefix + component.name, component)
    } else {
      console.error('组件注册失败：缺少name')
    }
  })
}
export default {
  install,
  province,
  city,
  district,
  formGroup,
  bdcSelect,
  asyncSelect,
  selectTree,
  editItem,
  remarkCell,
  editCell,
  textareaCell,
  towCascader,
  towTileSelect
}
